import {timeSeriesWidget, TimeSeriesWidget} from "./TimeSeriesWidgetComponent";

export default function(parentModule: string): string {
    const module = `${parentModule}.timeseries`;

    return angular.module(module, [])
                  .component(TimeSeriesWidget, timeSeriesWidget())
                  .name;
}
